var _path, _path2, _path3, _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGlitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 61,
    viewBox: "0 0 75 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.389 22.8586L35.1997 45.7172L21.968 22.8586H48.389ZM61.5782 15.2249H8.77871L35.1573 60.9421L61.5782 15.2249ZM0 0L4.41056 7.63367H65.9888L70.3994 0H0Z",
    fill: "#0037C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0744 22.8586L37.8851 45.7172L24.6534 22.8586H51.0744ZM64.2636 15.2249H11.4641L37.8427 60.9421L64.2636 15.2249ZM2.6854 0L7.09596 7.63367H68.6742L73.0848 0H2.6854Z",
    fill: "#DB1571"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3071 22.8586L37.1178 45.7172L23.8861 22.8586H50.3071ZM63.4964 15.2249H10.6968L37.0754 60.9421L63.4964 15.2249ZM1.91812 0L6.32868 7.63367H67.9069L72.3175 0H1.91812Z",
    fill: "#77F8BB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 30,
    width: 24,
    height: 11
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.8929,
    y: 30.5,
    width: 22.827,
    height: 9.5912,
    fill: "#151A35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.8929,
    y: 30.5,
    width: 23.0189,
    height: 9.5912,
    fill: "#0B0C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7725 22.8586L35.5832 45.7172L22.3515 22.8586H48.7725ZM61.9618 15.2249H9.16222L35.5408 60.9421L61.9618 15.2249ZM0.383514 0L4.79407 7.63367H66.3723L70.7829 0H0.383514Z",
    fill: "#DB1571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0869 22.8586L32.8977 45.7172L19.666 22.8586H46.0869ZM59.2762 15.2249H6.47668L32.8552 60.9421L59.2762 15.2249ZM-2.30203 0L2.10853 7.63367H63.6868L68.0973 0H-2.30203Z",
    fill: "#0037C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4298 22.8586L34.2405 45.7172L21.0088 22.8586H47.4298ZM60.619 15.2249H7.81951L34.1981 60.9421L60.619 15.2249ZM-0.959198 0L3.45136 7.63367H65.0296L69.4402 0H-0.959198Z",
    fill: "#77F8BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2119_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 24,
    width: 29,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7891,
    y: 24.3613,
    width: 27.239,
    height: 15.7296,
    fill: "#151A35"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2119_209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.7891,
    y: 24.3613,
    width: 25.5126,
    height: 15.7296,
    fill: "#0B0C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1844 22.8586L39.9951 45.7172L26.7634 22.8586H53.1844ZM66.3736 15.2249H13.5741L39.9527 60.9421L66.3736 15.2249ZM4.79541 0L9.20597 7.63367H70.7842L75.1948 0H4.79541Z",
    fill: "#DB1571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4988 22.8586L37.3096 45.7172L24.0779 22.8586H50.4988ZM63.6881 15.2249H10.8886L37.2671 60.9421L63.6881 15.2249ZM2.10987 0L6.52043 7.63367H68.0987L72.5092 0H2.10987Z",
    fill: "#0037C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8417 22.8586L38.6524 45.7172L25.4207 22.8586H51.8417ZM65.0309 15.2249H12.2314L38.61 60.9421L65.0309 15.2249ZM3.45271 0L7.86327 7.63367H69.4415L73.8521 0H3.45271Z",
    fill: "#77F8BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2119_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 0,
    width: 25,
    height: 7
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4495,
    width: 23.978,
    height: 6.52201,
    fill: "#151A35"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2119_209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.4495,
    width: 23.5943,
    height: 6.52201,
    fill: "#0B0C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4171 22.8586L39.2279 45.7172L25.9962 22.8586H52.4171ZM65.6064 15.2249H12.8069L39.1854 60.9421L65.6064 15.2249ZM4.02817 0L8.43873 7.63367H70.017L74.4275 0H4.02817Z",
    fill: "#DB1571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0744 22.8586L37.8851 45.7172L24.6535 22.8586H51.0744ZM64.2637 15.2249H11.4642L37.8427 60.9421L64.2637 15.2249ZM2.68546 0L7.09602 7.63367H68.6743L73.0848 0H2.68546Z",
    fill: "#77F8BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2119_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 16,
    height: 3
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.10985,
    y: 5.14062,
    width: 15.7296,
    height: 2.49371,
    fill: "#151A35"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2119_209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.10985,
    y: 5.14062,
    width: 14.7704,
    height: 2.49371,
    fill: "#0B0C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5397 26.2727L36.3504 49.1313L23.1187 26.2727H49.5397ZM62.7289 18.639H9.92941L36.308 64.3562L62.7289 18.639ZM1.1507 3.41406L5.56126 11.0477H67.1395L71.5501 3.41406H1.1507Z",
    fill: "#0037C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8825 26.2727L37.6932 49.1313L24.4615 26.2727H50.8825ZM64.0718 18.639H11.2722L37.6508 64.3562L64.0718 18.639ZM2.49354 3.41406L6.9041 11.0477H68.4823L72.8929 3.41406H2.49354Z",
    fill: "#77F8BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2119_209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 46,
    width: 30,
    height: 15
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1288,
    y: 46.9961,
    width: 29.7327,
    height: 14.0031,
    fill: "#151A35"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2119_209)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.1288,
    y: 46.9961,
    width: 27.8145,
    height: 14.0031,
    fill: "#0B0C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8418 22.8586L38.6525 45.7172L25.4208 22.8586H51.8418ZM65.031 15.2249H12.2315L38.6101 60.9421L65.031 15.2249ZM3.45279 0L7.86335 7.63367H69.4416L73.8522 0H3.45279Z",
    fill: "#DB1571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1562 22.8586L35.9669 45.7172L22.7352 22.8586H49.1562ZM62.3455 15.2249H9.54595L35.9245 60.9421L62.3455 15.2249ZM0.767242 0L5.1778 7.63367H66.7561L71.1666 0H0.767242Z",
    fill: "#0037C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4989 22.8586L37.3096 45.7172L24.0779 22.8586H50.4989ZM63.6882 15.2249H10.8887L37.2672 60.9421L63.6882 15.2249ZM2.10995 0L6.52051 7.63367H68.0988L72.5093 0H2.10995Z",
    fill: "#77F8BB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGlitch);
export default __webpack_public_path__ + "static/media/logo-glitch.b6ff81c9.svg";
export { ForwardRef as ReactComponent };